import React from 'react';

interface LicenseModalPageProps {
  licenseData: any;
  onClose: () => void;
}

export function LicenseModalPage({ onClose }: LicenseModalPageProps) {
  return (
    <div style={{ position: 'fixed', inset: 0, width: '100vw', height: '100vh', zIndex: 99999, background: '#0a1833' }}>
      <iframe
        src="https://getlicense.solanavolumebot.io/app"
        title="License App"
        width="100%"
        height="100%"
        style={{ border: 'none', minHeight: '100vh', width: '100vw', borderRadius: 0 }}
        allow="clipboard-write"
      />
      <button onClick={onClose} style={{ position: 'absolute', top: 24, right: 32, zIndex: 100000, background: 'rgba(20,241,149,0.18)', border: 'none', borderRadius: '50%', width: 48, height: 48, fontSize: 28, color: '#14F195', cursor: 'pointer', boxShadow: '0 2px 8px #0002' }}>{t('licensemodal._times_')}</button> // replaced by script
    </div>
  );
}

export { LicenseModalPage as LicenseModal };